import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export function ResetPassword() {
  const [senha, setSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    if (senha !== confirmacao) {
      setErro("As senhas não coincidem.");
      return;
    }
    if (senha.length < 6) {
      setErro("A senha deve ter pelo menos 6 caracteres.");
      return;
    }
    setEnviando(true);
    const { error } = await supabase.auth.updateUser({ password: senha });
    setEnviando(false);
    if (error) {
      setErro("Não foi possível definir a nova senha. Solicite um novo link.");
      return;
    }
    navigate("/", { replace: true });
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <form onSubmit={onSubmit} className="card" style={{ width: "100%", maxWidth: 360, display: "flex", flexDirection: "column", gap: 14 }}>
        <h1 style={{ fontSize: 26 }}>Definir nova senha</h1>
        <p style={{ color: "var(--text-muted)", margin: 0, fontSize: 14 }}>Escolha uma nova senha para sua conta.</p>
        <input
          className="input"
          type="password"
          placeholder="Nova senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          required
        />
        <input
          className="input"
          type="password"
          placeholder="Confirmar nova senha"
          value={confirmacao}
          onChange={(e) => setConfirmacao(e.target.value)}
          required
        />
        {erro && <p style={{ color: "#B3452F", fontSize: 13, margin: 0 }}>{erro}</p>}
        <button className="btn btn-primary" type="submit" disabled={enviando}>
          {enviando ? "Salvando..." : "Salvar nova senha"}
        </button>
      </form>
    </div>
  );
}
